import {Post, PostFull} from "@/api/post";
import blog from "@/styles/modules/blog.module.scss";
import React from "react";
import VadImage from "vadimages-nextjs-image-optimizer";

export interface PostCardParams {
    post: Post | PostFull;
}
export default async function PostCard({post}: PostCardParams){
    let date = new Date(post.publishDate);
    let dateMDY = `${date.toLocaleString('default', { month: 'long' })} ${date.getDate()}, ${date.getFullYear()}`;

return (
    <div className={blog.blog_lists__item} key={`post${post.id}`}>
        <a href={`/news/${post.slug}`}>
            <VadImage src={post.featuredImage} alt={''} width={768} height={220} className={blog.blog_lists__item__image}/>
            <div className={blog.blog_lists__item__text}>
                <p className={`h6`}>{post.title}</p>
                <p className={`p3`}>{dateMDY}</p>
            </div>
        </a>
    </div>
)
}